var UNIVERSAL = {
  BASEURL: "https://www.talabulilm.com",
}

export default UNIVERSAL;